import React from 'react'

function Ontologies (props) {
  return (
    <svg
      width='20'
      height='14'
      fill='none'
      viewBox='0 0 20 14'
      {...props}
    >
      <path fill='#000023' stroke='#fff' strokeOpacity='0.5' d='M0.5 0.5H19.5V13.5H0.5z' />
      <path
        fill='#fff'
        d='M6.722 8.102a.95.95 0 00.938-.938.949.949 0 00-.938-.93.934.934 0 100 1.868zM9.999 8.102a.95.95 0 00.937-.938.949.949 0 00-.937-.93.934.934 0 100 1.868zM13.275 8.102a.95.95 0 00.937-.938.949.949 0 00-.937-.93.934.934 0 100 1.868z'
      />
    </svg>
  )
}

export default Ontologies
